import script from "./ProductPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductPage.vue?vue&type=style&index=0&id=7e495ea5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e495ea5"]])

export default __exports__